export default {
  displayName: 'Scheme name',
  description: 'Scheme description',
  partIds: 'Parts',
  assetIds: 'Assets',
};
